import { styled } from "@mui/system";
import React from "react";

export default function PhotoContainer({ children, src }) {
	const PhotoContainer = styled("img")(({ theme }) => ({
		backgroundColor: theme.palette.primary.faded,
		borderRadius: "10px",
		padding: "20px",
		borderStyle: "solid",
		borderColor: theme.palette.primary.main,
		borderWidth: "1px",
		// maxHeight: "250px",
		// height: "100%",
		width: "100%",
		// [theme.breakpoints.up("xs")]: {
		// 	maxWidth: "100%",
		// },
		// [theme.breakpoints.up("sm")]: {
		// 	maxWidth: "60%",
		// },
	}));
	return <PhotoContainer src={src} />;
}
